import React from "react";
import { Button, Tooltip } from "antd";
import { CiClock2 } from "react-icons/ci";
import { FaPlus } from "react-icons/fa";
import {
  ClockCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import TimeOffIcon from "../../../../assets/icons/TimeOff.svg";
import VectorIcon from "../../../../assets/icons/Vector.svg";
const TimeSheetButton = ({
  isTimeOff = false,
  isAlreadyConfTimeSheetByAnotherEmployer = false,
  currentEmployerTimesheetIsAlreadyConfigured = false,
  isActiveTimeSheets = false,
  isNeitherCurrentNorOtherEmployerConfigured = false,
  handleConfigTimeSheetClick,
  handleViewTimeSheet,
  handleTimeOff,
  disableConfigButton,
}) => {
  const _disableConfigButton =
    disableConfigButton ||
    isAlreadyConfTimeSheetByAnotherEmployer ||
    currentEmployerTimesheetIsAlreadyConfigured;

  return (
    <span
      style={{
        display: "flex",
        flexDirection: "row",
        // flexWrap: "nowrap",
        justifyContent: "flex-start",
        columnGap: "2px",
      }}
    >
      {currentEmployerTimesheetIsAlreadyConfigured ||
      isAlreadyConfTimeSheetByAnotherEmployer ? (
        <ViewTimeSheetButton onClick={handleViewTimeSheet} />
      ) : (
        <ConfigTimeSheetButton
          disabled={_disableConfigButton}
          onClick={handleConfigTimeSheetClick}
        />
      )}
      {isAlreadyConfTimeSheetByAnotherEmployer ? (
        <QuestionCircleButton />
      ) : null}
      {isTimeOff ? <TimeOffButton handleTimeOff={handleTimeOff} /> : null}
    </span>
  );
};

export default TimeSheetButton;
const ViewTimeSheetButton = (props) => {
  return (
    <Button
      type="primary"
      size="small"
      icon={<ClockCircleOutlined size={14} />}
      {...props}
      style={{
        position: "relative",
        bottom: "5px",
        left: "4px",
      }}
    >
      View Timesheet
    </Button>
  );
};

const ConfigTimeSheetButton = (props) => {
  return (
    <Button
      type="primary"
      ghost
      size="small"
      icon={<PlusOutlined size={14} />}
      {...props}
      style={{
        position: "relative",
        bottom: "5px",
        left: "4px",
      }}
    >
      Configure Timesheet
    </Button>
  );
};

function QuestionCircleButton() {
  return (
    <Tooltip
      title={
        <div>
          <div style={{ fontSize: "12px", marginTop: "4px" }}>
            Timesheet configured by another employer
          </div>
        </div>
      }
    >
      <div style={{ marginLeft: "10px", lineHeight: "1.1" }}>
        <img src={VectorIcon} alt="?-icon" />
      </div>
    </Tooltip>
  );
}
function TimeOffButton({ handleTimeOff }) {
  return (
    <Tooltip title="Time Off Request">
      <span
        onClick={(e) => {
          e?.stopPropagation();
          handleTimeOff();
        }}
      >
        <img
          src={TimeOffIcon}
          alt="icon"
          style={{
            cursor: "pointer",
            position: "relative",
            left: "7px",
            bottom: "4px",
          }}
        />
      </span>
    </Tooltip>
  );
}
